import { render, staticRenderFns } from "./ReserveListAdmin.vue?vue&type=template&id=448ef8dd&scoped=true&"
import script from "./ReserveListAdmin.vue?vue&type=script&lang=js&"
export * from "./ReserveListAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ef8dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
